import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    products: [],
}

export const productHistorySlice = createSlice({
    name: 'productHistory',
    initialState,
    reducers: {
        addToHistory: (state, { payload }) => {
            for (let index = 0; index < state.products.length; index++) {
                const id = state.products[index]['product_id']
                if (id === payload.product_id) return
            }
            if (state.products.length >= 5)
                state.products = state.products.slice(0, 4)
            state.products.unshift(payload)
            window.localStorage.setItem(
                'productsHistory',
                JSON.stringify(state.products)
            )
        },
    },
})

export const { addToHistory } = productHistorySlice.actions
export default productHistorySlice.reducer
